// Feature flags configuration for Benipal Toys website

export interface FeatureFlags {
  showProducts: boolean;
  showVideos: boolean;
  showOffers: boolean;
  showInstagram: boolean;
  showGoogleReviews: boolean;
  showNewsletter: boolean;
}

// Default feature flags - can be overridden by environment variables or admin settings
export const defaultFeatureFlags: FeatureFlags = {
  showProducts: true,
  showVideos: true,
  showOffers: true,
  showInstagram: true,
  showGoogleReviews: true,
  showNewsletter: true,
};

// Feature flag utility functions
export const getFeatureFlags = (): FeatureFlags => {
  // In a real application, this could fetch from an API or environment variables
  // For now, we'll use the default flags
  return defaultFeatureFlags;
};

export const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
  const flags = getFeatureFlags();
  return flags[feature];
};

// Environment-based feature flags (can be set via VITE_ environment variables)
export const getEnvironmentFeatureFlags = (): Partial<FeatureFlags> => {
  const flags: Partial<FeatureFlags> = {};

  // Check for environment variables
  if (import.meta.env.VITE_SHOW_PRODUCTS !== undefined) {
    flags.showProducts = import.meta.env.VITE_SHOW_PRODUCTS === "true";
  }

  if (import.meta.env.VITE_SHOW_VIDEOS !== undefined) {
    flags.showVideos = import.meta.env.VITE_SHOW_VIDEOS === "true";
  }

  if (import.meta.env.VITE_SHOW_OFFERS !== undefined) {
    flags.showOffers = import.meta.env.VITE_SHOW_OFFERS === "true";
  }

  if (import.meta.env.VITE_SHOW_INSTAGRAM !== undefined) {
    flags.showInstagram = import.meta.env.VITE_SHOW_INSTAGRAM === "true";
  }

  if (import.meta.env.VITE_SHOW_GOOGLE_REVIEWS !== undefined) {
    flags.showGoogleReviews =
      import.meta.env.VITE_SHOW_GOOGLE_REVIEWS === "true";
  }

  if (import.meta.env.VITE_SHOW_NEWSLETTER !== undefined) {
    flags.showNewsletter = import.meta.env.VITE_SHOW_NEWSLETTER === "true";
  }

  return flags;
};

// Merge environment flags with defaults
export const getEffectiveFeatureFlags = (): FeatureFlags => {
  const defaultFlags = defaultFeatureFlags;
  const envFlags = getEnvironmentFeatureFlags();

  return {
    ...defaultFlags,
    ...envFlags,
  };
};
